export default "__VITE_ASSET__BAlITzsk__"